// extracted by mini-css-extract-plugin
var _1 = "UvpLaBudY43tAluR68CG";
export { _1 as "flow-mo-timer" }
